import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import formControl from './formControl';
import * as styles from './styles.css';

function PaymentPeriodSelect({
  input: { value, onChange, onBlur },
  paymentPeriods,
  disabled,
  isEditable
}) {
  if(!isEditable)
  {
    let selectedItem = paymentPeriods.find((item)=>{
      if(item.value == value)
          return item;
    })
    return <div className={`${styles.capitalizeText} ${styles.value}`}>{selectedItem ? selectedItem.name : ' - '}</div>
  }
  else
    return (
      <select
        className="form-control"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      >
        {!value &&
          <option key="null-option" value="null"> - </option>
        }
        {paymentPeriods.map(paymentPeriod => (
          <option
            key={paymentPeriod.value}
            value={paymentPeriod.value}
          >
            {paymentPeriod.name}
          </option>
        ))}
      </select>
    );
}

PaymentPeriodSelect.defaultProps = {
  paymentPeriods: [
    { value: 'weekly', name: 'Varje vecka' },
    { value: 'every_2_weeks', name: 'Varannan vecka' },
    { value: 'monthly', name: 'En gång i månaden' }
  ],
  disabled: false,
  isEditable: true,
};

PaymentPeriodSelect.propTypes = {
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool
};

export default compose(  
  formControl,
)(PaymentPeriodSelect);
